<template>
    <div>
      <meta-info>
        <title>Testimonial Mx - inte-QT</title>
        <meta name="title" content="Testimonial Mx - inte-QT" />
        <meta name="description" content="We asked the Associate Director of Media Services a few questions about the experience of us serving at this event..." />
        <link rel="canonical" href="https://www.inte-qt.com/testimonials/mx" />
      </meta-info>
  
      <img src="/images/6Q7TYsB.jpg" alt="bigbanner-background" class="banner-img banner-img__black" />
      <h1 class="banner-img__header banner-img__black">Brilliant Work</h1>
  
      <div class="container-fluid caseFiji">
        <div class="container">
          <div class="caseFiji__aux">
            <p class="caseFiji__title text-center center-header mx-auto">
              <font-awesome-icon icon="quote-left" class="me-2" />
              <span class="blue">Brilliant work by inte-QT</span>
              <font-awesome-icon icon="quote-right" class="ms-2" />
            </p>
  
            <p>We asked the Associate Director of Media Services a few questions about the experience of us serving at this event:</p>
  
            <p><strong class="testimonials__question">Describe the Project, Challenge and Goals:</strong><br><br>
              This is a media event and mostly the venues are at remote places... remote production facilities.
            </p>
  
            <p><strong class="testimonials__question">How did we come to your mind?</strong><br><br>
              inte-QT is a global VNO aggregator... You guys offer first class connectivity.
            </p>
  
            <p><strong class="testimonials__question">What finally made you to decide, it´s inte-QT?</strong><br><br>
              Promptness and agile to manage last moment changes...
            </p>
  
            <p><strong class="testimonials__question">How was our first level impact after you finalized us?</strong><br><br>
              The solution offered along with commercials and all other details...
            </p>
  
            <p><strong class="testimonials__question">How we manage the project?</strong><br><br>
              It was seamlessly managed by inte-QT...
            </p>
  
            <p><strong class="testimonials__question">How did we deliver?</strong><br><br>
              On Dot – as it was agreed in the specs and within timelines.
            </p>
  
            <p><strong class="testimonials__question">Moments we made a total difference</strong><br><br>
              Regular updates and follow-ups on deliverables with onsite engagement.
            </p>
  
            <p><strong class="testimonials__question">How did we finish the job?</strong><br><br>
              <span class="blue">Brilliant.</span>
            </p>
  
            <p><strong class="testimonials__question">Do you refer us for future projects?</strong><br><br>
              That proves inte-QT’s ability to be utilized for more and more events like that...
            </p>
  
            <p><strong class="testimonials__question">How was your overall experience working with inte-QT?</strong><br><br>
              Delighted Experience.
            </p>
          </div>
  
          <EventsComponent />
        </div>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import { defineComponent, onMounted } from 'vue';
  import EventsComponent from '@/components/EventsComponent.vue';
  import GetInTouch from '@/components/GetInTouch.vue';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  
  export default defineComponent({
    name: 'TestimonialMx',
    components: {
      EventsComponent,
      GetInTouch,
      FontAwesomeIcon
    },
    setup() {
      onMounted(() => {
        window.scrollTo(0, 0);
      });
    }
  });
  </script>
  
  <style scoped>
  @import '@/assets/css/Variables.css';
  
  .testimonials__question {
    font-weight: 600;
  }
  
  .caseFiji {
    padding: 2rem 0;
  }
  
  .caseFiji__title {
    font-size: 1.8rem;
    font-weight: bold;
  }
  
  .banner-img {
    width: 100%;
    height: auto;
  }
  
  .banner-img__header {
    position: absolute;
    width: 60vw;
    top: 40vh;
    left: 4vw;
    line-height: 1.5;
    font-size: 4rem;
    font-weight: 1000;
    color: #fff;
}
  .blue {
    color: #007bff;
  }
  
  .mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  
  .me-2 {
    margin-right: 0.5rem;
  }
  
  .ms-2 {
    margin-left: 0.5rem;
  }
  </style>
  